module.exports = __webpack_public_path__ + "static/media/settings.598bd30e.svg";